module.exports = __webpack_public_path__ + "img/1.5063bf47.jpg";